<template>
  <span class="progress-bar"><span></span></span>
</template>

<script>
export default {
  name: 'InfiniteProgressBarCmp'
}
</script>

<style scoped>
  @keyframes progress_anime {
    0% {
      margin-left: -100%;
    }
    100% {
      margin-left: 100%;
    }
  }

  .progress-bar {
    display: block;
    width: 100%;
    height: 2px;
    margin: 24px 0 0 0;
    background: #c0d5ef;
    overflow: hidden;
  }

  .progress-bar span {
    display: block;
    width: 100%;
    height: 2px;
    background: #6ba7ef;

    animation: progress_anime 2s infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/progress/infinite-progress-bar.vue